/*eslint @typescript-eslint/member-delimiter-style: "off"*/
/*eslint @typescript-eslint/no-explicit-any: "off"*/

declare global {
	interface Window {
		onApplicationBooted: () => void | null;
		onNativeNotificationReceived: (notification: Notification) => void | null;

		sendNativeMessage<T = void>(data?: object): Promise<T>;

		AppData: {
			Platform: 'web' | 'ios' | 'android'
		}
	}
}

export declare type Notification = {
	origin: 'selected' | 'received';
	data: any;
	remote: boolean;
	isMultiple: boolean;
	notificationId: number;
	userText: string | null;
	actionId: any;
};

export interface AlertButton {
	text?: string;
	onPress?: (value?: string) => void;
	style?: 'default' | 'cancel' | 'destructive';
}

interface AlertOptions {
	/** @platform android */
	cancelable?: boolean;
	/** @platform android */
	onDismiss?: () => void;
}

export interface NotificationState {
	token: string | null;
}

export async function nativeAlert(message: string, title?: string, buttons?: AlertButton[], options?: AlertOptions) {
	let buttonIndex: number | undefined;
	const response = await window.sendNativeMessage<{ buttonIndex: number | undefined }>({ messageType: 'native-alert', message, title, buttons, options });
	if (typeof response == 'object' && 'buttonIndex' in response) {
		if (buttons && typeof response.buttonIndex == 'number' && buttons.length > response.buttonIndex) {
			const button = buttons[response.buttonIndex];
			if (button.onPress) button.onPress();
			buttonIndex = response.buttonIndex;
		}
	}
	return buttonIndex;
}

export function nativeEval<T = void>(code: string) {
	return window.sendNativeMessage<T>({ messageType: 'native-eval', code: code });
}

export function nativeNotificationsState() {
	return window.sendNativeMessage<NotificationState>({ messageType: 'native-notification-state' });
}

enum SignInAsyncResult {
	SUCCESS = 'SUCCESS',
	FAILED = 'FAILED',
	INVALID_TOKEN = 'INVALID_TOKEN',
	NO_URL = 'NO_URL'
}
export function nativeAuth<T = {
	result: SignInAsyncResult,
	userMeta: any,
	token: string | null
}>() {
	return window.sendNativeMessage<T>({ messageType: 'native-auth' });
}

export enum WebBrowserResultType {
	/**
	 * iOS only
	 */
	CANCEL = 'cancel',
	/**
	 * iOS only
	 */
	DISMISS = 'dismiss',
	/**
	 * Android only
	 */
	OPENED = 'opened',
	LOCKED = 'locked',
}

export function nativeOpenBrowser(url: string, browserParams?: any) {
	return window.sendNativeMessage<{ result: WebBrowserResultType }>({ messageType: 'native-open-browser', url, browserParams, });
}

export function nativePrint(html: string) {
	return window.sendNativeMessage<{}>({ messageType: 'native-print', html, });
}

interface ExcelData {
	data: unknown[];
	workbook: string;
	filename: string;
	dialogTitle: string;
}
export function nativeExcelExport(request: ExcelData) {
	return window.sendNativeMessage<{}>({ messageType: 'native-excel', ...request });
}

export interface LinkingMessageData {
  operation: 'openURL';
  openURL?: string;
}

export function nativeLinking(message: LinkingMessageData) {
	return window.sendNativeMessage<{}>({ messageType: 'native-linking', ...message });
}
